import {
	showToast,
	openId,
	token,
	getUserInfo,
	setAnswer,
	logData,
	verifyCode,
	clearCanvas,
	watchKeyboardByVisualViewport
} from '../api/public.js'
import {
	CAR_GIFT_CHECKIN_RULE_CODE,
	CAR_LOG_CHECKIN_POINTS,
	CAR_TOAST_SEAL_SUCCESS_MS
} from '../api/config.js'
import {
	applyGiftCheckinVerifyLayout,
	bindGiftCheckinVerifyResize,
	syncGiftCheckinVisual,
	unbindGiftCheckinVerifyResize
} from '../utils/gift-checkin-zone.js'
import {
	applyLogCheckinVerifyLayout,
	bindLogCheckinVerifyResize,
	unbindLogCheckinVerifyResize
} from '../utils/log-checkin-zone.js'
import { ensureCarPageAuth, blockPage } from '../api/auth.js'
import {
	initCarShakeLottery,
	destroyCarShakeLottery,
	tryShakeMotionPermissionFromUserGesture
} from './shake-lottery.js'
import {
	initPasswordHotspotCodes,
	registerPasswordCheckinHandlers,
	syncAllPasswordHotspots
} from './password-hotspot.js'
import { cvQuery, cvQueryAll } from '../utils/dom.js'

var activeIndex = null;

function runAfterLoad(fn) {
	if (document.readyState === 'complete') {
		fn();
	} else {
		window.addEventListener('load', fn);
	}
}

function animateHomeSlideHeader() {}

function animateGiftSlideHeader() {}

function animateLogSlideHeader() {}

const HOME_CHECK_AUTO_ENTER_MS = 3000
let homeCheckAutoEnterTimer = null

function clearHomeCheckAutoEnterTimer() {
	if (homeCheckAutoEnterTimer != null) {
		clearTimeout(homeCheckAutoEnterTimer)
		homeCheckAutoEnterTimer = null
	}
}

function isHomeCheckOverlayVisible() {
	const overlay = cvQuery('#homeCheck')
	if (!overlay || overlay.hidden) return false
	return overlay.classList.contains('is-show')
}

/** 欢迎页展示后 3 秒未点击「即刻探索」则自动进入摇享好礼 */
function scheduleHomeCheckAutoEnter() {
	clearHomeCheckAutoEnterTimer()
	homeCheckAutoEnterTimer = setTimeout(function () {
		homeCheckAutoEnterTimer = null
		if (!isHomeCheckOverlayVisible()) return
		const swiper = window.__carvueSwiper
		enterCarHomeSlide(swiper)
		pageShow()
	}, HOME_CHECK_AUTO_ENTER_MS)
}

/** loading 结束后：确认页（无底部菜单） */
function showHomeCheckPage() {
	const overlay = cvQuery('#homeCheck');
	const paginationBox = cvQuery('.swiper-pagaBox');
	if (paginationBox) paginationBox.style.display = 'none';
	if (overlay) {
		overlay.hidden = false;
		overlay.setAttribute('aria-hidden', 'false');
		overlay.classList.add('is-show');
	}
	syncAllPasswordHotspots();
	scheduleHomeCheckAutoEnter();
}

/** 点击确认页热区后进入摇享好礼（home_slide，index=0） */
function enterCarHomeSlide(swiper) {
	clearHomeCheckAutoEnterTimer();
	const overlay = cvQuery('#homeCheck');
	if (overlay) {
		overlay.classList.remove('is-show');
		overlay.hidden = true;
		overlay.setAttribute('aria-hidden', 'true');
	}
	if (!swiper) return;
	tryShakeMotionPermissionFromUserGesture();
	swiper.slideTo(0, 0);
	activeIndex = 0;
	const paginationBox = cvQuery('.swiper-pagaBox');
	if (paginationBox) {
		paginationBox.style.display = 'block';
		paginationBox.classList.remove('animate');
		void paginationBox.offsetWidth;
		paginationBox.classList.add('animate');
	}
	initCarShakeLottery();
	syncAllPasswordHotspots();
	animateHomeSlideHeader();
}

function bindHomeCheckHotspot(swiper) {
	const btn = cvQuery('#homeCheckHotspot');
	if (!btn || btn.__carBound) return;
	btn.__carBound = true;
	btn.addEventListener('click', function () {
		enterCarHomeSlide(swiper);
		pageShow();
	});
}

async function init() {
	initPasswordHotspotCodes()
	registerCarPasswordCheckinHandlers()
	const iconList = ['摇享好礼','互动打卡','拉享好礼','问卷调查'];
	const swiperEl = cvQuery('.mySwiper')
	if (!swiperEl) throw new Error('页面结构未就绪')
	const pagEl = cvQuery('.swiper-pagaBox-item')
	if (!pagEl) throw new Error('底栏未就绪')
	const swiper = new Swiper(swiperEl, {
		direction: "vertical",
		initialSlide: 0,
		noSwiping: true,
		noSwipingSelector: '.form_slide_div',
		on:{
			slideChangeTransitionStart: function(){
				activeIndex = this.activeIndex;
				const paginationBox = cvQuery('.swiper-pagaBox');
				if (!paginationBox) return;
				paginationBox.classList.remove('animate');
				void paginationBox.offsetWidth;
				if(this.activeIndex === 0){
					tryShakeMotionPermissionFromUserGesture();
					paginationBox.classList.add('animate');
					initCarShakeLottery();
					syncAllPasswordHotspots();
					animateHomeSlideHeader();
				}else{
					destroyCarShakeLottery();
					syncAllPasswordHotspots();
				}
				if(this.activeIndex === 1){
					applyLogCheckinVerifyLayout()
					bindLogCheckinVerifyResize()
					const runLogCanvas = function () {
						initCanvas('checkinCanvas1')
					}
					if (window.requestAnimationFrame) {
						window.requestAnimationFrame(runLogCanvas)
					} else {
						runLogCanvas()
					}
					paginationBox.classList.add('animate')
					animateLogSlideHeader()
					syncAllPasswordHotspots()
				}else if (this.activeIndex === 2) {
					applyGiftCheckinVerifyLayout()
					bindGiftCheckinVerifyResize()
					const runGiftCanvas = function () {
						initCanvas('checkinCanvas2')
					}
					if (window.requestAnimationFrame) {
						window.requestAnimationFrame(runGiftCanvas)
					} else {
						runGiftCanvas()
					}
					paginationBox.style.display = 'block'
					paginationBox.classList.add('animate')
					animateGiftSlideHeader()
					syncAllPasswordHotspots()
				}else if (this.activeIndex === 3) {
					paginationBox.classList.add('animate');
				}
			},
		},
		pagination: {
			el: pagEl,
			clickable: true,
			hideOnClick :true,
			renderBullet: function (index, className) {
				return '<div class="' + className + '"><i class="icon-'+ (index + 1) +'"></i><span>'+ iconList[index] +'</span></div>';
			},
		},
	});

	const paginationBox = cvQuery('.swiper-pagaBox');
	window.__carvueSwiper = swiper;
	bindHomeCheckHotspot(swiper);
	runAfterLoad(() => {
		const loadingOverlay = cvQuery('#loading');
		if (loadingOverlay) {
			loadingOverlay.style.transition = 'opacity 200ms ease';
			loadingOverlay.style.opacity = '0';
			loadingOverlay.style.pointerEvents = 'none';
			setTimeout(() => {
				loadingOverlay.remove();
			}, 220);
		}
		showHomeCheckPage();
	});

	bindCustomRadio(['.radio-liOne', '.radio-liTwo']);

	function getSurveyBlockText(ul, selector) {
		const el = ul && ul.querySelector(selector)
		return el ? String(el.textContent || '').trim() : ''
	}

	function bindCustomRadio(selectors) {
		selectors.forEach(function (sel) {
			cvQueryAll(sel).forEach(function (btn) {
				btn.addEventListener('click', function () {
					const block = btn.parentElement.parentElement
					block.querySelectorAll(sel).forEach(function (b) {
						b.classList.remove('checkedRadio')
					})
					btn.classList.add('checkedRadio')
					const radio = btn.querySelector('input[type="radio"]')
					if (radio) radio.checked = true
				})
			})
		})
	}

	cvQuery('.form_slide_btn').addEventListener('click',async function () {
		let form = cvQuery('.form_slide_div');
		let suggestion = form.querySelector('#suggestion');
		let uls = form.querySelectorAll(':scope > ul');
		let tipEls = form.querySelectorAll(':scope > p.tips');
		let allOk = true;
		tipEls.forEach(function (p) { p.classList.remove('show'); });
		uls.forEach(function (ul, i) {
			let q3Textarea = ul.querySelector('textarea#suggestion');
			if (q3Textarea) {
				if (!suggestion || suggestion.value.trim() === '') {
					allOk = false;
					if (tipEls[i]) tipEls[i].classList.add('show');
				}
			} else {
				let checked = ul.querySelector('input[type="radio"]:checked');
				if (!checked) {
					allOk = false;
					if (tipEls[i]) tipEls[i].classList.add('show');
				}
			}
		});
		if (!allOk) return
		const q1Text = getSurveyBlockText(uls[0], '.form_q_text')
		const q2Text = getSurveyBlockText(uls[1], '.form_q_text')
		const q3Text = getSurveyBlockText(uls[2], '.form_q_text')
		const q1Checked = uls[0].querySelector('input[type="radio"]:checked')
		const q2Checked = uls[1].querySelector('input[type="radio"]:checked')
		const q1Answer = q1Checked ? q1Checked.value : ''
		const q2Answer = q2Checked ? q2Checked.value : ''
		const data = await setAnswer({
			q1Text: q1Text,
			q1Answer: q1Answer,
			q2Text: q2Text,
			q2Answer: q2Answer,
			q3Text: q3Text,
			q3Suggestion: suggestion.value.trim()
		})
		if (data.code == 200) {
			await pageShow()
			showSurveySubmittedOverlay(true)
			showToast('success', '提交成功')
		} else {
			if (data.message && /已经提交/.test(String(data.message))) {
				await pageShow()
				showToast('success', data.message)
			} else {
				showToast('error', data.message || '提交失败')
			}
		}
	});

	const ta = cvQuery('#suggestion')
	let stop = null
	if (ta) {
		ta.addEventListener('focus', () => {
			const paginationBox = cvQuery('.swiper-pagaBox')
			stop = watchKeyboardByVisualViewport(({ open }) => {
				if (!paginationBox) return
				if (open === true) {
					paginationBox.style.display = 'none'
				}
				if (open === false) {
					paginationBox.style.display = 'block'
				}
			})
		})
	}
}
const pageShow = async function () { 
	let data = null
	//获取用户信息
	try{
		if (!openId() || !token()) return;
		data = await getUserInfo();
	}catch(e){
		syncGiftCheckinVisual(new Set());
		return;
	}
	let signlog = Array.isArray(data && data.data && data.data.signlog) ? data.data.signlog : [];
	const pointSet = buildLogCheckinPointSet(signlog);
	syncLogSlideCheckinVisual(pointSet);
	syncGiftCheckinVisual(pointSet);
	var surveyForm = cvQuery('.form_slide_div')
	if (surveyForm) {
		surveyForm.style.display = ''
	}
	// 提交问卷回显（保留表单可见，渲染已选选项）
	let answerlog = Array.isArray(data && data.data && data.data.answerlog) ? data.data.answerlog : []
	if (answerlog.length >= 1) {
		const hasAnswers = applySurveyAnswerlog(answerlog[0])
		if (hasAnswers) {
			lockSurveyFormSubmitted(cvQuery('.form_slide_div'))
			showSurveySubmittedOverlay(false)
		}
	}
	syncAllPasswordHotspots()
};	

const SURVEY_OPTION_LETTER_MAP = {
	A: '满意',
	B: '一般',
	C: '不满意'
}

function normalizeSurveyRecord(last) {
	if (!last) return null
	if (last.q1Answer || last.q2Answer || last.q3Suggestion) {
		return {
			q1Answer: last.q1Answer != null ? String(last.q1Answer).trim() : '',
			q2Answer: last.q2Answer != null ? String(last.q2Answer).trim() : '',
			q3Suggestion:
				last.q3Suggestion != null ? String(last.q3Suggestion) : ''
		}
	}
	var rawQ = last.q
	var q = null
	try {
		q = typeof rawQ === 'string' ? JSON.parse(rawQ) : rawQ
	} catch (e) {
		console.warn('answerlog.q 解析失败', e)
	}
	if (!Array.isArray(q) || q.length < 3) {
		return null
	}
	function mapSurveyOption(val) {
		if (val == null || val === '') return ''
		var s = String(val).trim()
		var upper = s.toUpperCase()
		if (SURVEY_OPTION_LETTER_MAP[upper]) {
			return SURVEY_OPTION_LETTER_MAP[upper]
		}
		return s
	}
	return {
		q1Answer: mapSurveyOption(q[0]),
		q2Answer: mapSurveyOption(q[1]),
		q3Suggestion: q[2] != null ? String(q[2]) : ''
	}
}

function applySurveyRadioAnswer(form, name, rowSel, answer) {
	var val = answer != null ? String(answer).trim() : ''
	if (!val || !form) return
	form.querySelectorAll(rowSel).forEach(function (li) {
		li.classList.remove('checkedRadio')
	})
	var input = form.querySelector(
		'input[type="radio"][name="' + name + '"][value="' + val + '"]'
	)
	if (!input) return
	input.checked = true
	var li = input.closest('.radio-li')
	if (li) li.classList.add('checkedRadio')
}

function applySurveyAnswerlog(last) {
	var form = cvQuery('.form_slide_div')
	if (!form) return false
	form.style.display = ''
	var norm = normalizeSurveyRecord(last)
	if (!norm) return false
	applySurveyRadioAnswer(form, 'q1', '.radio-liOne', norm.q1Answer)
	applySurveyRadioAnswer(form, 'q2', '.radio-liTwo', norm.q2Answer)
	var suggestion = cvQuery('#suggestion')
	if (suggestion) {
		suggestion.value = norm.q3Suggestion || ''
	}
	return !!(norm.q1Answer || norm.q2Answer || norm.q3Suggestion)
}

function lockSurveyFormSubmitted(form) {
	if (!form) return
	form.classList.add('is-submitted')
	var fields = form.querySelectorAll('input, textarea, button')
	for (var i = 0; i < fields.length; i++) {
		fields[i].disabled = true
	}
	var btn = form.querySelector('.form_slide_btn')
	if (btn) btn.style.display = 'none'
}

function showSurveySubmittedOverlay(show) {
	var fiexd_Box = cvQuery('#fiexd_Box')
	var paginationBox = cvQuery('.swiper-pagaBox')
	if (fiexd_Box) {
		fiexd_Box.hidden = !show
		fiexd_Box.classList.toggle('is-show', !!show)
	}
	if (paginationBox && show) {
		paginationBox.style.display = 'none'
	}
}


let isCheckinSubmitting = false; //加锁 防止连续触发
let nextAllowedCheckinAt = 0; //下次允许打卡时间
/** 互动打卡已完成点位（one/three），与 signlog 同步，避免重复请求 validateSeal */
let logCheckinDonePointSet = new Set()

function getLogSlideCheckinEl(pointCfg) {
	if (!pointCfg) return null
	return cvQuery('.log_slide_div_item.' + pointCfg.itemClass)
}

function getCheckinRuleCodes(pointCfg) {
	if (!pointCfg) return []
	if (Array.isArray(pointCfg.ruleCodes) && pointCfg.ruleCodes.length) {
		return pointCfg.ruleCodes
	}
	if (pointCfg.ruleCode) return [pointCfg.ruleCode]
	return []
}

function buildLogCheckinPointSet(signlog) {
	return new Set(
		(signlog || [])
			.map(function (item) {
				return item && item.point
			})
			.filter(Boolean)
	)
}

function markLogSlidePointDone(pointCfg) {
	if (pointCfg && pointCfg.legacyPoint) {
		logCheckinDonePointSet.add(pointCfg.legacyPoint)
	}
}

function isLogSlidePointChecked(pointCfg) {
	if (!pointCfg) return false
	if (pointCfg.legacyPoint && logCheckinDonePointSet.has(pointCfg.legacyPoint)) {
		return true
	}
	const el = getLogSlideCheckinEl(pointCfg)
	return !!(el && (el.classList.contains('is-done') || el.classList.contains('cur')))
}

function getPendingLogCheckinPoints() {
	const pending = []
	for (let i = 0; i < CAR_LOG_CHECKIN_POINTS.length; i++) {
		const cfg = CAR_LOG_CHECKIN_POINTS[i]
		if (!isLogSlidePointChecked(cfg)) {
			pending.push(cfg)
		}
	}
	return pending
}

function logSlideSpanHtml(label) {
	const text = label || ''
	return (
		'<span class="log_slide_span"><i></i><i></i><i></i><i></i>' +
		'<span class="log_slide_label">' +
		text +
		'</span></span>'
	)
}

/** 未打卡：地图上方标签 + 竖线指向 icondian；已打卡：高亮标签 */
function setLogSlidePointUnchecked(pointCfg) {
	const el = getLogSlideCheckinEl(pointCfg)
	if (!el) return
	el.className = 'log_slide_div_item log_slide_item ' + pointCfg.itemClass
	el.innerHTML = logSlideSpanHtml(pointCfg.label)
}

function setLogSlidePointChecked(pointCfg) {
	markLogSlidePointDone(pointCfg)
	const el = getLogSlideCheckinEl(pointCfg)
	if (!el) return
	el.className =
		'log_slide_div_item log_slide_item ' + pointCfg.itemClass + ' is-done'
	el.innerHTML = '<b></b>' + logSlideSpanHtml(pointCfg.label)
}

function syncLogSlideCheckinVisual(pointSet) {
	const serverSet = pointSet || new Set()
	serverSet.forEach(function (p) {
		logCheckinDonePointSet.add(p)
	})
	CAR_LOG_CHECKIN_POINTS.forEach(function (cfg) {
		if (logCheckinDonePointSet.has(cfg.legacyPoint)) {
			setLogSlidePointChecked(cfg)
		} else {
			setLogSlidePointUnchecked(cfg)
		}
	})
}

const touchLog = async function (touchesArr, checkinCanvas) {
	const now = Date.now()
	if (isCheckinSubmitting || now < nextAllowedCheckinAt) {
		return false
	}
	if (!openId() || !token()) {
		showToast('error', '登录已失效，请从活动入口重新进入')
		return false
	}
	if (!touchesArr || touchesArr.length !== 4) {
		return false
	}

	if (checkinCanvas === 'checkinCanvas1') {
		const pendingPoints = getPendingLogCheckinPoints()
		if (!pendingPoints.length) {
			clearCanvas(checkinCanvas)
			showToast('success', '两个打卡点均已完成', CAR_TOAST_SEAL_SUCCESS_MS)
			return true
		}
		isCheckinSubmitting = true
		let lastError = ''
		try {
			for (let i = 0; i < pendingPoints.length; i++) {
				const cfg = pendingPoints[i]
				const ruleCodes = getCheckinRuleCodes(cfg)
				if (!ruleCodes.length) {
					continue
				}
				const code = ruleCodes[0]
				const res = await verifyCode(touchesArr, code)
				clearCanvas(checkinCanvas)
				if (res && res.matched) {
					setLogSlidePointChecked(cfg)
					const data = await logData()
					if (data.code == 200) {
						const msg =
							(res.errorMessage && String(res.errorMessage).trim()) ||
							data.message ||
							'打卡成功'
						showToast('success', msg, CAR_TOAST_SEAL_SUCCESS_MS)
						await pageShow()
					}
					return true
				}
				if (res && res.errorMessage) {
					lastError = String(res.errorMessage)
				}
			}
			if (lastError) {
				showToast('error', lastError)
			} else {
				showToast('error', '打卡失败，请重试')
			}
		} catch (e) {
			clearCanvas(checkinCanvas)
			showToast('error', e.message)
		} finally {
			nextAllowedCheckinAt = Date.now() + 1500
			isCheckinSubmitting = false
		}
		return true
	}

	if (checkinCanvas === 'checkinCanvas2') {
		const giftState =
			cvQuery('.gift_checkin_status_img') &&
			cvQuery('.gift_checkin_status_img').getAttribute('data-gift-state')
		if (giftState === 'locked') {
			showToast('error', '请先完成互动打卡两个打卡点')
			clearCanvas(checkinCanvas)
			return true
		}
		if (giftState === 'redeemed') {
			showToast('info', '已核销')
			clearCanvas(checkinCanvas)
			return true
		}
		isCheckinSubmitting = true
		try {
			const res = await verifyCode(touchesArr, CAR_GIFT_CHECKIN_RULE_CODE)
			clearCanvas(checkinCanvas)
			if (res && res.matched) {
				const data = await logData()
				if (data.code == 200) {
					const msg =
						(res.errorMessage && String(res.errorMessage).trim()) ||
						data.message ||
						'核销成功'
					showToast('success', msg, CAR_TOAST_SEAL_SUCCESS_MS)
					await pageShow()
				}
				return true
			}
			if (res && res.errorMessage) {
				showToast('error', res.errorMessage)
			} else {
				showToast('error', '核销失败，请重试')
			}
		} catch (e) {
			clearCanvas(checkinCanvas)
			showToast('error', e.message)
		} finally {
			nextAllowedCheckinAt = Date.now() + 1500
			isCheckinSubmitting = false
		}
		return true
	}
	return false
}

function findLogCheckinPointCfg(legacyPoint) {
	for (let i = 0; i < CAR_LOG_CHECKIN_POINTS.length; i++) {
		if (CAR_LOG_CHECKIN_POINTS[i].legacyPoint === legacyPoint) {
			return CAR_LOG_CHECKIN_POINTS[i]
		}
	}
	return null
}

async function submitLogPasswordCheckinForPoint(legacyPoint, touchesArr) {
	const cfg = findLogCheckinPointCfg(legacyPoint)
	if (!cfg || isLogSlidePointChecked(cfg)) {
		return false
	}
	const now = Date.now()
	if (isCheckinSubmitting || now < nextAllowedCheckinAt) {
		return false
	}
	if (!openId() || !token()) {
		showToast('error', '登录已失效，请从活动入口重新进入')
		return false
	}
	if (!touchesArr || touchesArr.length !== 4) {
		return false
	}
	isCheckinSubmitting = true
	try {
		const res = await verifyCode(touchesArr, cfg.ruleCode)
		clearCanvas('checkinCanvas1')
		if (res && res.matched) {
			setLogSlidePointChecked(cfg)
			const data = await logData()
			if (data.code == 200) {
				const msg =
					(res.errorMessage && String(res.errorMessage).trim()) ||
					data.message ||
					'打卡成功'
				showToast('success', msg, CAR_TOAST_SEAL_SUCCESS_MS)
				await pageShow()
			}
			return true
		}
		if (res && res.errorMessage) {
			showToast('error', String(res.errorMessage))
		} else {
			showToast('error', '打卡失败，请重试')
		}
	} catch (e) {
		clearCanvas('checkinCanvas1')
		showToast('error', e.message)
	} finally {
		nextAllowedCheckinAt = Date.now() + 1500
		isCheckinSubmitting = false
	}
	return false
}

async function submitGiftPasswordCheckin(touchesArr) {
	const giftState =
		cvQuery('.gift_checkin_status_img') &&
		cvQuery('.gift_checkin_status_img').getAttribute('data-gift-state')
	if (giftState !== 'unlocked') {
		showToast('info', giftState === 'redeemed' ? '已核销' : '请先完成互动打卡两个打卡点')
		return false
	}
	const now = Date.now()
	if (isCheckinSubmitting || now < nextAllowedCheckinAt) {
		return false
	}
	if (!openId() || !token()) {
		showToast('error', '登录已失效，请从活动入口重新进入')
		return false
	}
	if (!touchesArr || touchesArr.length !== 4) {
		return false
	}
	isCheckinSubmitting = true
	try {
		const res = await verifyCode(touchesArr, CAR_GIFT_CHECKIN_RULE_CODE)
		clearCanvas('checkinCanvas2')
		if (res && res.matched) {
			const data = await logData()
			if (data.code == 200) {
				const msg =
					(res.errorMessage && String(res.errorMessage).trim()) ||
					data.message ||
					'核销成功'
				showToast('success', msg, CAR_TOAST_SEAL_SUCCESS_MS)
				await pageShow()
			}
			return true
		}
		if (res && res.errorMessage) {
			showToast('error', String(res.errorMessage))
		} else {
			showToast('error', '核销失败，请重试')
		}
	} catch (e) {
		clearCanvas('checkinCanvas2')
		showToast('error', e.message)
	} finally {
		nextAllowedCheckinAt = Date.now() + 1500
		isCheckinSubmitting = false
	}
	return false
}

function registerCarPasswordCheckinHandlers() {
	registerPasswordCheckinHandlers({
		isLogPointAvailable: function (legacyPoint) {
			const cfg = findLogCheckinPointCfg(legacyPoint)
			return !!(cfg && !isLogSlidePointChecked(cfg))
		},
		isGiftAvailable: function () {
			const img = cvQuery('.gift_checkin_status_img')
			return !!(img && img.getAttribute('data-gift-state') === 'unlocked')
		},
		submitLogPoint: submitLogPasswordCheckinForPoint,
		submitGift: submitGiftPasswordCheckin
	})
}

const canvasCleanupMap = new Map()

export async function startCarvuePage() {
	const ok = await ensureCarPageAuth()
	if (!ok) return false
	if (!window.Swiper) {
		blockPage('页面组件加载失败，请刷新重试')
		return false
	}
	try {
		await init()
		try {
			await pageShow()
		} catch (e) {
			syncLogSlideCheckinVisual(new Set())
			syncGiftCheckinVisual(new Set())
		}
		applyLogCheckinVerifyLayout()
		bindLogCheckinVerifyResize()
		applyGiftCheckinVerifyLayout()
		bindGiftCheckinVerifyResize()
	} catch (e) {
		console.error('[carvue] init 失败', e)
		blockPage((e && e.message) || '页面加载失败')
		return false
	}
	return true
}

export function stopCarvuePage() {
	clearHomeCheckAutoEnterTimer()
	unbindLogCheckinVerifyResize()
	unbindGiftCheckinVerifyResize()
	destroyCarShakeLottery()
	if (window.__carvueSwiper) {
		try {
			window.__carvueSwiper.destroy(true, true)
		} catch (e) {
			// ignore
		}
		window.__carvueSwiper = null
	}
	canvasCleanupMap.forEach(function (fn) {
		try {
			fn()
		} catch (e) {
			// ignore
		}
	})
	canvasCleanupMap.clear()
}


function resolveSealTouchTarget(checkinCanvas) {
	if (checkinCanvas === 'checkinCanvas1') {
		return cvQuery('.log_checkin_verify_zone') || cvQuery('.checkinCanvas1')
	}
	if (checkinCanvas === 'checkinCanvas2') {
		return cvQuery('.gift_checkin_verify_zone') || cvQuery('.checkinCanvas2')
	}
	return cvQuery('.' + checkinCanvas)
}

function initCanvas(checkinCanvas) {
	const oldCleanup = canvasCleanupMap.get(checkinCanvas)
	if (oldCleanup) {
		oldCleanup()
		canvasCleanupMap.delete(checkinCanvas)
	}
	const standardWidth = 800
	const standardHeight = 600
	const canvas = cvQuery('.' + checkinCanvas)
	const touchTarget = resolveSealTouchTarget(checkinCanvas)
	if (!canvas || !touchTarget) {
		console.log('未找到画布或盖章热区:', checkinCanvas)
		return
	}

	var hasSubmittedThisGesture = false
	var submitPromise = null

	function collectTouchPoints(e) {
		var src =
			e.touches && e.touches.length
				? e.touches
				: e.targetTouches && e.targetTouches.length
					? e.targetTouches
					: []
		if (!src.length) return []
		var rect = touchTarget.getBoundingClientRect()
		if (!rect.width || !rect.height) return []
		var list = []
		var n = src.length >= 4 ? 4 : src.length
		for (var i = 0; i < n; i++) {
			var t = src[i]
			var x = t.clientX - rect.left
			var y = t.clientY - rect.top
			list.push([
				Math.round((x / rect.width) * standardWidth),
				Math.round((y / rect.height) * standardHeight)
			])
		}
		return list
	}

	/** 检测到 4 触点即请求后端印章比对，不再做本地几何拦截 */
	function submitOnce(points) {
		if (hasSubmittedThisGesture || submitPromise) return
		if (!points || points.length !== 4) return
		hasSubmittedThisGesture = true
		submitPromise = touchLog(points, checkinCanvas)
			.then(function (started) {
				if (started === false) {
					hasSubmittedThisGesture = false
				}
			})
			.catch(function () {
				hasSubmittedThisGesture = false
			})
			.finally(function () {
				submitPromise = null
			})
	}

	function onTouchStartOrMove(e) {
		e.preventDefault()
		var pts = collectTouchPoints(e)
		if (pts.length === 4) {
			submitOnce(pts)
		}
	}

	function onTouchEnd(e) {
		e.preventDefault()
		if (!e.touches || e.touches.length === 0) {
			hasSubmittedThisGesture = false
		}
	}

	touchTarget.addEventListener('touchstart', onTouchStartOrMove, { passive: false })
	touchTarget.addEventListener('touchmove', onTouchStartOrMove, { passive: false })
	touchTarget.addEventListener('touchend', onTouchEnd, { passive: false })
	touchTarget.addEventListener('touchcancel', onTouchEnd, { passive: false })

	const cleanup = function () {
		touchTarget.removeEventListener('touchstart', onTouchStartOrMove)
		touchTarget.removeEventListener('touchmove', onTouchStartOrMove)
		touchTarget.removeEventListener('touchend', onTouchEnd)
		touchTarget.removeEventListener('touchcancel', onTouchEnd)
	}
	canvasCleanupMap.set(checkinCanvas, cleanup)

	clearCanvas(checkinCanvas)
}